// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10950":"5798f44b","12752":"0c154995","32622":"0c154995","34963":"7472cffb","58872":"0c154995","88056":"5798f44b"}[chunkId] + ".chunk.css";
};